module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-sidenav', {
    ref: "leftSidenav",
    staticClass: "md-left",
    on: {
      "open": function($event) {
        return _vm.open()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('md-toolbar', {
    staticClass: "md-large main-toolbar"
  }, [_c('div', {
    staticClass: "md-toolbar-container ql-toolbar-logo"
  }, [_c('h1', [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Cuelist")]), _vm._v(" "), _c('img', {
    staticClass: "logo-text",
    attrs: {
      "src": require('../../../assets/img/cuelisttextWHITE.png'),
      "alt": "cuelisttext"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require('../../../assets/img/cuelist.png'),
      "alt": "cuelist"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "md-toolbar-container ql-toolbar-avatar"
  }, [_c('md-avatar', {
    staticClass: "md-small"
  }, [(_vm.user.profile_picture) ? _c('img', {
    attrs: {
      "src": _vm.user.profile_picture,
      "alt": "People"
    }
  }) : _c('img', {
    attrs: {
      "src": require('../../../assets/img/silhouette.jpg'),
      "alt": "People"
    }
  })]), _vm._v(" "), (_vm.user.username) ? _c('div', {
    staticClass: "md-subtitle avatar-name-role"
  }, [_vm._v(_vm._s(_vm.user.username))]) : _c('div', {
    staticClass: "md-subtitle avatar-name-role"
  }, [_vm._v("Cuelist User")])], 1)]), _vm._v(" "), _c('md-list', [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      },
      "tag": "md-list-item"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.projectsClick()
      }
    }
  }, [_vm._v("All Projects")])]), _vm._v(" "), (_vm.project && _vm.project.id) ? _c('md-list-item', {
    staticClass: "md-list-item-project-title-lock"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.project.title))])]), _vm._v(" "), (_vm.canToggleLock) ? _c('div', {
    staticClass: "project-lock-toggle"
  }, [_c('md-switch', {
    attrs: {
      "id": "locked",
      "name": "locked"
    },
    on: {
      "change": _vm.toggleLocked
    },
    model: {
      value: (_vm.localLocked),
      callback: function($$v) {
        _vm.localLocked = $$v
      },
      expression: "localLocked"
    }
  }, [_vm._v("Project Lock")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.project && _vm.project.id) ? _c('md-list-item', [_c('md-list', [_c('md-list-item', {
    on: {
      "click": function($event) {
        return _vm.collaboratorsClick()
      }
    }
  }, [_c('span', [_vm._v("Collaborators")])]), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        return _vm.layersClick()
      }
    }
  }, [_c('span', [_vm._v("Layers")])]), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        return _vm.historyClick()
      }
    }
  }, [_c('span', [_vm._v("History")])]), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        return _vm.projectSettingsClick()
      }
    }
  }, [_c('span', [_vm._v("Project Settings")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "md-list-item",
      "to": {
        name: 'account'
      }
    }
  }, [_c('span', [_vm._v("Account Settings")])]), _vm._v(" "), _c('md-list-item', [_c('div', {
    staticClass: "md-button md-list-item-container"
  }, [_c('span', [_vm._v("Help")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-button-ghost",
    on: {
      "click": _vm.helpClick
    }
  })], 1), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        return _vm.logoutClick()
      }
    }
  }, [_c('span', [_vm._v("Log Out")])])], 1)], 1), _vm._v(" "), (_vm.project && _vm.project.id) ? _c('layers-nav', {
    on: {
      "close": function($event) {
        return _vm.closeMainNav()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project && _vm.project.id) ? _c('collaborators-nav', {
    on: {
      "close": function($event) {
        return _vm.closeMainNav()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project && _vm.project.id) ? _c('print-nav', {
    on: {
      "close": function($event) {
        return _vm.closeMainNav()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project && _vm.project.id && _vm.user) ? _c('project-settings-nav', {
    attrs: {
      "currentPage": _vm.currentPage,
      "cuePlacement": _vm.getProjectCuePlacement(),
      "projectduplicateSettingLocked": _vm.getlockedDuplicateSettingProject(),
      "collabDuplicateProjectLocked": _vm.getDuplicateProjectLocked(),
      "showMode": _vm.showMode
    },
    on: {
      "close": function($event) {
        return _vm.closeMainNav()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project && _vm.project.id) ? _c('history-nav', {
    on: {
      "close": function($event) {
        return _vm.closeMainNav()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66498908","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/nav/main.vue
// module id = 1255
// module chunks = 21